import { type ReactElement } from 'react'
import {
  isAccountId,
  isAreaId,
  isCompanyId,
  isStrictFeatureId,
  isTeamId,
  isUserId,
  isValidEmail,
  isWorkflowId,
} from '@terros/common'
import { Spotlight } from '@mantine/spotlight'
import { Avatar } from '@mantine/core'
import { useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '../terros/icon/MaterialSymbolIcon'
import { UserEmailItem, UserIdItem } from './DetectedUserItems'
import { type DetectedIdActionProps } from './DetectedIdAction'
import { AccountIdItem, AreaIdItem, CompanyIdItem, TeamIdItem, WorkflowIdItem } from './DetectedEntityItems'

export const DetectedIdItem = (props: DetectedIdActionProps): ReactElement => {
  const { t } = useTranslation()
  const { detected, onNavigate } = props
  const { id } = detected
  if (isAccountId(id)) return <AccountIdItem {...props} accountId={id} />
  if (isAreaId(id)) return <AreaIdItem {...props} areaId={id} />
  if (isWorkflowId(id)) return <WorkflowIdItem {...props} workflowId={id} />
  if (isUserId(id)) return <UserIdItem {...props} userId={id} />
  if (isValidEmail(id)) return <UserEmailItem {...props} email={id} />
  if (isTeamId(id)) return <TeamIdItem {...props} teamId={id} />
  if (isCompanyId(id)) return <CompanyIdItem {...props} companyId={id} />
  return (
    <Spotlight.Action
      label={isStrictFeatureId(id) ? id.replace('Feature:', '') : t('Go to {{type}}', { type: detected.type })}
      description={isStrictFeatureId(id) ? `${t(detected.type)} · ${id}` : id}
      leftSection={
        <Avatar size={36} radius='xl'>
          <MaterialSymbolIcon icon='link' size='xl' />
        </Avatar>
      }
      onClick={() => onNavigate(detected.url)}
    />
  )
}
